module.exports = __webpack_public_path__ + "img/ary.c9757b71.svg";